import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import theme from '../theme';
import { useT } from '../i18n/langContext.js';

// Shown in place of the AI mentor for Free users — disabled state + upsell.
export default function MentorUpsell({ onClose, onUpgrade }) {
  const t = useT();
  return (
    <Box
      sx={{
        position: 'absolute', top: 16, right: 16, zIndex: 20, width: 320, maxWidth: '90vw',
        bgcolor: theme.home.ink, color: theme.home.paper, borderRadius: 4, p: 3,
        boxShadow: '0 24px 60px -20px rgba(0,0,0,0.55)', border: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AutoAwesomeIcon sx={{ color: theme.home.cyan }} />
          <Typography sx={{ fontWeight: 700 }}>{t('chat.mentorUpsell.title')}</Typography>
        </Box>
        {onClose && (
          <IconButton size="small" onClick={onClose} sx={{ color: 'rgba(251,248,244,0.7)' }} aria-label={t('chat.mentorUpsell.closeAria')}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Typography sx={{ color: 'rgba(251,248,244,0.78)', fontSize: '0.95rem', lineHeight: 1.6, mb: 2.5 }}>
        {t('chat.mentorUpsell.body')}
      </Typography>
      <Button
        fullWidth variant="contained" onClick={onUpgrade}
        sx={{ borderRadius: 999, bgcolor: theme.home.cyan, fontWeight: 700, '&:hover': { bgcolor: theme.home.cyanHover } }}
      >
        {t('chat.mentorUpsell.cta')}
      </Button>
    </Box>
  );
}
